<template>
  <div class="auth-wrapper auth-">
    <b-row class="auth-inner m-0">
      <b-col md="2" />
      <b-col
        lg="8"
        class="d-flex align-items-center justify-content-center px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="7"
          class="px-xl-2 mx-auto"
        >
          <div class="login-page">
            <div class="logo-container">
              <img
                v-if="$route.query.target_package"
                src="@/assets/images/logo/verolabs-logo.png"
                alt="VEROlabs Logo"
                class="login-logo"
              >
              <b-link
                v-else
                :to="{ name: 'home' }"
              >
                <img
                  src="@/assets/images/logo/verolabs-logo.png"
                  alt="VEROlabs Logo"
                  class="login-logo"
                >
              </b-link>
            </div>
          </div>

          <validation-observer
            ref="emailForm"
            v-slot="{ invalid }"
          >
            <b-form @submit.prevent="forgotPassword">
              <b-form-group class="mb-2">

                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <div class="input-container">
                    <feather-icon
                      icon="MailIcon"
                      class="input-icon"
                      size="18"
                    />
                    <b-form-input
                      id="login-email"
                      v-model="emailForm.email"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Email"
                      class="login-input"
                      name="login-email"
                    />
                  </div>
                  <!-- <b-input-group>
                    <b-input-group-prepend is-text>
                      <feather-icon icon="MailIcon" size="18" />
                    </b-input-group-prepend>
                    <b-form-input
                      id="login-email"
                      v-model="emailForm.email"
                      :state="errors.length > 0 ? false : null"
                      name="login-email"
                      placeholder="Email"
                    />
                  </b-input-group> -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group class="mt-3">
                <b-button
                  type="submit"
                  variant="primary"
                  class="w-100 d-flex align-items-center justify-content-center"
                  :disabled="invalid || loadAction"
                >
                  <span v-if="!loadAction">Send Reset Link</span>
                  <b-spinner
                    v-else
                    small
                    type="grow"
                  />
                </b-button>
              </b-form-group>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>

      <b-col md="2" />
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormCheckbox,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormCheckbox,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      emailForm: {
        email: null,
      },
      loadAction: false,
      required,
      email,
    }
  },
  methods: {
    forgotPassword() {
      const payload = {
        query: {
          email: this.emailForm.email,
        },
      }

      this.$refs.emailForm.validate().then(success => {
        if (!success) return

        this.loadAction = true

        this.$store
          .dispatch('users/forgotPassword', payload)
          .then(response => {
            this.$swal({
              icon: 'success',
              title: 'Email Sent',
              text: response?.data?.message || 'Check your email inbox.',
            })
          })
          .catch(error => {
            this.$swal({
              icon: 'error',
              title: 'Oops!',
              text:
                error?.response?.data?.message
                || 'Something went wrong. Please try again.',
            })
          })
          .finally(() => {
            this.loadAction = false
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.auth-wrapper {
  background-color: #000a1e;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

input.form-control,
textarea.form-control {
  background-color: #141c2c !important;
  border: none !important;
  border-radius: 12px !important;
  color: #fff !important;
  font-size: 16px;
  caret-color: #fff;
}

input.form-control:focus,
textarea.form-control:focus {
  outline: none;
  box-shadow: 0 0 0 1px #4c84ff inset;
}
.input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.input-icon {
  position: absolute;
  left: 15px;
  color: rgba(255, 255, 255, 0.8);
}
.login-input {
  height: 50px;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 12px;
  color: #ffffff !important;
  padding: 0 15px 0 40px;
  width: 100%;
  transition: 0.3s ease;
}

button[type="submit"] {
  background: linear-gradient(90deg, #7f2ac9 0%, #3b82f6 100%) !important;
  border: none;
  border-radius: 12px;
  color: #fff !important;
  font-weight: 600;
  letter-spacing: 1px;
  transition: opacity 0.2s ease-in-out;
}

button[type="submit"]:hover {
  opacity: 0.85;
}

.forgot-pass {
  color: #fff;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
}

.b-input-group-prepend {
  background-color: #141c2c;
  border-radius: 12px 0 0 12px;
  display: flex;
  align-items: center;
  padding-left: 12px;
}

.feather-icon {
  color: #b8b8b8 !important;
}

input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #141c2c inset !important;
  -webkit-text-fill-color: #fff !important;
  caret-color: #fff !important;
}
.login-page {
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo-container {
  text-align: center;
  margin-bottom: 30px;
}
</style>
